<template>
  <fieldset class="form-section-group mt-4 mb-4">
    <legend class="section-legend" :id="'section-legend-' + filter.id">
      {{ filter.label }}
      <div class="mr-2" v-if="filter.helpLink">
        <a
          :href="filter.helpLink"
          target="_blank"
          style="color: black"
          :aria-label="`Help for ${filter.label}`"
        >
          <b-icon
            class="ml-2"
            :id="filter.id"
            icon="question-circle-fill"
            aria-hidden="true"
          ></b-icon>
        </a>
      </div>
    </legend>
    <div class="ml-4 mt-2">
      <div v-for="(row, rowIndex) in filter.rows" :key="rowIndex" class="row">
        <div class="col-sm-4">
          <div class="d-flex">
            <label
              v-if="row.name"
              :id="'row-label-' + filter.id + '-' + rowIndex"
              class="text-left fw-bold form-label pt-2"
              style="height: 20px; color: black"
            >
              {{ row.name }}
            </label>
            <div class="mr-2" v-if="row.helpLink">
              <a
                :href="row.helpLink"
                target="_blank"
                style="color: black"
                :aria-label="`Help for ${row.name}`"
              >
                <b-icon
                  class="ml-2"
                  :id="row.id"
                  icon="question-circle-fill"
                  aria-hidden="true"
                ></b-icon>
              </a>
            </div>
          </div>
        </div>
        <div
          class="col-lg-8 col-md-12 col-sm-12 d-flex flex-column flex-md-row container"
        >
          <fieldset class="row-controls-group">
            <legend class="sr-only">{{ row.name || "Form controls" }}</legend>
            <element-builder
              v-for="(element, index) in filter.rows[rowIndex].value.elements"
              :key="index"
              :element="element"
              :row-label-id="'row-label-' + filter.id + '-' + rowIndex"
              @element-changed="$emit('element-changed', $event)"
              @on-enter="$emit('on-enter', $event)"
            />
          </fieldset>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import ElementBuilder from "./ElementBuilder.vue";

export default {
  name: "FormSection",
  components: {
    ElementBuilder,
  },
  props: {
    filter: Object,
  },
};
</script>
<style scoped lang="scss">
.form-label {
  font-size: 18px;
  color: #777;
  font-weight: bold;
}
.col-lg-8.col-md-12.col-sm-12.d-flex.flex-column {
  align-items: flex-start;
}
@media (min-width: 768px) {
  .container > div {
    margin-left: 20px; /* Example margin size, adjust as needed */
  }
}

// Accessibility fieldset styles
.form-section-group {
  border: none;
  margin: 0;
  padding: 0;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.section-legend {
  font-size: 1.25rem;
  font-weight: bold;
  color: black;
  margin-bottom: 0.5rem;
  padding: 0;
  border: none;
  width: auto;
  display: flex;
  align-items: center;
}

// Screen reader only legend for row controls
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

// Row controls group styling - maintain original flex layout
.row-controls-group {
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;

  // Ensure child elements maintain proper spacing
  > * {
    margin-left: 0;
  }
}

@media (min-width: 768px) {
  .row-controls-group {
    flex-direction: row;
    align-items: center;

    // Restore the original margin for child elements
    > * {
      margin-left: 20px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}

// Ensure the container maintains its original behavior
.container .row-controls-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

@media (min-width: 768px) {
  .container .row-controls-group {
    flex-direction: row;
    align-items: center;
  }
}

.form-section-group .row {
  margin-bottom: 1.25rem;
}
</style>
